export const localStorageItemsKeyName = { DISCOUNT_CAMPAIGN_ERROR_ITEMS: 'discountCampaignErrorItems', UPLOAD_BUNDLE_ERROR_ITEMS: 'uploadBundleErrorItems' };
